import { FC, ReactNode, useRef } from 'react'
import type { TrackSlidesConfigOption } from 'keen-slider'
import s from './SectionMainCarousel.module.sass'
import { Carousel } from '@shared/ui/Layout/Carousel'
import IconArrow from '@icons/icon-arrow-cover.svg'
import { ContainerLong } from '@shared/ui/Layout/Containers/ContainerLong'
import { useFeatureAutoScroll } from './hooks/useFeatureAutoScroll'

interface Props {
  children: ReactNode[]
  className?: string
}

const MOBILE_SLIDE_SPACING = 8

// вообще это хуйня конечно, я просто не знал, что keen-slider не поддерживает snap-align: center по-человечески
// если хочется удалить, то просто держите в голове, что крайние карточки не должны быть в центре, а промежуточные должны
const getCenteredMobileSlides = (containerSize: number, slides: HTMLElement[]): TrackSlidesConfigOption => {
  if (!containerSize) return []

  const lastIndex = slides.length - 1

  return slides.map((slide, index) => {
    const size = slide.offsetWidth / containerSize
    let origin = 0.5 - size / 2

    if (index === 0) origin = 0
    else if (index === lastIndex) origin = 1 - size

    // промежуток уже внутри слайда, отдельный spacing раздвинет карточки ещё раз
    return { origin, size, spacing: 0 }
  })
}

const SectionMainCarousel: FC<Props> = ({ children, className = '', ...props }) => {
  return (
    <ContainerLong {...props}>
      <Carousel analytic={{ section_name: 'Главный слайдер' }}>
        <SectionMainCarouselBody className={className}>{children}</SectionMainCarouselBody>
      </Carousel>
    </ContainerLong>
  )
}

const SectionMainCarouselBody: FC<Props> = ({ children, className = '' }) => {
  const rootRef = useRef<HTMLDivElement>(null)
  const controlsRef = useRef<HTMLDivElement>(null)

  useFeatureAutoScroll({ rootRef, controlsRef })

  return (
    <div ref={rootRef} className={s.wrapper}>
      <div ref={controlsRef} className={s.controls}>
        <Carousel.Arrow direction={'prev'} className={s['arrow-prev']}>
          <IconArrow />
        </Carousel.Arrow>
        <Carousel.Arrow direction={'next'} className={s['arrow-next']}>
          <IconArrow />
        </Carousel.Arrow>
      </div>
      <Carousel.Slider
        className={`${s.slider} ${className}`}
        spacingMobile={MOBILE_SLIDE_SPACING}
        spacingDesktop={16}
        slideMoveCount={2}
        optionsKeenSlider={{
          breakpoints: {
            '(max-width: 767px)': {
              slides: getCenteredMobileSlides,
            },
          },
        }}>
        {children}
      </Carousel.Slider>
    </div>
  )
}

export default SectionMainCarousel
